import { createFileRoute } from '@tanstack/react-router';
import { TasksList } from '../../../../features/customer/tasks/list';
import { getTasksOptions } from '../../../../features/customer/tasks/queryOptions';
import { validateSearch } from '../../../../utils/pagination';
import { mapInitialFilters } from '../../../../utils/filter/utils';

export const Route = createFileRoute(
  '/_authenticated/customers/$guid/_layout/tasks',
)({
  component: Page,
  loaderDeps: ({ search }) => search,
  loader: ({ context: { queryClient }, deps: search, params: { guid } }) => {
    const searchWithDefaultFilters = search.filter
      ? search
      : { ...search, filter: ['status,in_review'] };
    return queryClient.ensureQueryData(
      getTasksOptions(guid, mapInitialFilters(searchWithDefaultFilters)),
    );
  },
  validateSearch: validateSearch,
});

function Page() {
  const data = Route.useLoaderData();

  return (
    <div className="col-span-full flex items-center justify-between">
      <TasksList tasks={data} />
    </div>
  );
}
